exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb[data-v-4fcaa5c9]{padding:12px 15px;font-size:13px;color:#666}.breadcrumb .sep[data-v-4fcaa5c9]{margin:0 6px;color:#c0c4cc}.filter-bar[data-v-4fcaa5c9]{display:flex;flex-wrap:wrap;align-items:center;gap:10px}.export-btn[data-v-4fcaa5c9]{margin-left:auto}.pager[data-v-4fcaa5c9]{margin-top:12px;text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4fcaa5c9&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/UniversityManage/UniversityManage/SportsStatistic/SportsStatistic.vue
// module id = 526
// module chunks = 0